var _path, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23564 11.9515L3.65936 9.34457L0.925382 6.54923C0.730351 6.34424 0.676623 6.04631 0.747866 5.78517C0.818162 5.52526 1.04917 5.31928 1.31544 5.2825L5.07853 4.70505L6.76493 1.12726C6.88872 0.885743 7.13748 0.717774 7.40375 0.717774C7.67002 0.717774 7.91878 0.866362 8.04257 1.12726L9.72897 4.70505L10.4052 4.80881",
    stroke: "#4F4F4F",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3042 14.0032C3.51674 14.171 3.81899 14.1896 4.04929 14.0594L7.42209 12.1958L10.7949 14.0594C10.9012 14.1158 11.0074 14.1526 11.1324 14.1526C11.2746 14.1526 11.4337 14.0964 11.5587 14.0032C11.7712 13.8353 11.8784 13.5557 11.8425 13.2762L11.2036 9.34433L13.9374 6.54899C14.1326 6.344 14.2037 6.04608 14.1149 5.78493C13.9708 5.5054 13.7582 5.31904 13.4919 5.28227L12.1266 5.07275",
    stroke: "#4F4F4F",
    strokeWidth: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.05798,
    y1: 14.0824,
    x2: 13.0341,
    y2: 2.1063,
    stroke: "#4F4F4F",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfavoriteIcon);
export default __webpack_public_path__ + "static/media/unfavorite-icon.d5663fa645208f3dd6a5a57ca057ba0d.svg";
export { ForwardRef as ReactComponent };